export default "__VITE_ASSET__CWizs1Ez__"